import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

type Props = {
  hoverEffect?: boolean;
};

export default makeStyles<Props>()((theme, { hoverEffect }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    '& input[type="radio"]': {
      /* Add if not using autoprefixer */
      WebkitAppearance: 'none',
      appearance: 'none',
      /* For iOS < 15 to remove gradient background */
      backgroundColor: '#fff',
      /* Not removed via appearance */
      margin: 0,
      font: 'inherit',
      width: rem(24),
      height: rem(24),
      border: `${rem(1)} solid ${theme.palette.neutral[700]}`,
      borderRadius: '50%',
      minWidth: rem(24),
      '&:hover': {
        boxShadow: `0px 0px 0px ${rem(4)} ${theme.palette.primary.main}1F`,
      },
      boxShadow: hoverEffect
        ? `0px 0px 0px ${rem(4)} ${theme.palette.primary.main}1F`
        : 'none',
    },

    '& input[type="radio"]:checked': {
      border: `${rem(8)} solid ${theme.palette.primary[400]}`,
    },
    height: 'fit-content',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: rem(8),
  },
}));
